export default "__VITE_ASSET__DiUOht1D__"